// 基于 axios 封装的请求模块
import ajax from 'axios'
import router from '@/router/index.js'
import { Notify } from 'vant'
import { getToken } from '@/utils/token.js'
// 新建一个新的axios实例
const axios = ajax.create({
  baseURL: 'http://geek.itheima.net/' // 基地址
})

// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么, 如果vuex里有token携带在请求头中
  // 目标： 统一拦截token
  // 判断本地有token再携带，判断具体api/index.js里如果没有携带Authorization,
  // 则添加上去
  // 未定义叫undefined, 具体的值未定义叫null
  if (getToken()?.length > 0 && config.headers.Authorization === undefined) { // ?.可选量操作符，如果对象里面没有length, 原地返回undefined
    config.headers.Authorization = `Bearer ${getToken()}` // 如果本地有token，则进行拼接
    // 如果getToken里有值，才调用length获取长度
  }
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 添加响应拦截器
axios.interceptors.response.use(function (response) { // 当状态码为2xx/3xx开头的进这里
  // 对响应数据做点什么
  return response
}, function (error) { // 响应状态码4xx/5xx进这里
  // 只有401才代表身份国企，才需要跳转登录
  if (error.response.status === 401) {
    Notify({ type: 'warning', message: '身份已过期' })
    router.replace('/login') // 错误写法This.router.replace，this未定义,需要引入router
  }
  return Promise.reject(error)
})

// 导出自定义函数, 参数对象解构赋值
export default ({ url, method = 'GET', params = {}, data = {}, headers = {} }) => {
  return axios({
    url: url,
    method: method,
    params: params,
    data: data,
    headers: headers
  })

// 以后换库, 只需要改这里, 逻辑页面不用动, 保证代码的复用性和独立性(高内聚低耦合)
//   return $.ajax({
//     url: url,
//     type: method,
//     data: data,
//     header: headers
//   })
}
